<template>
    <div class="input-group">
        <input :id="id"
               ref="input"
               :disabled="disabled"
               :name="name"
               :required="required"
               v-model="inputValue"
               class="form-control"
               :class="{'is-invalid': invalid || empty}"
               type="tel"
               @change="change"
               @blur="change"
        />
        <span class="invalid-feedback" :class="{'d-block': empty}">{{ $t('validation.required', {_field_: label}) }}</span>
        <span class="invalid-feedback" :class="{'d-block': !empty && invalid}">{{ $t('validation.regex', {_field_: label}) }}</span>
    </div>
</template>

<script>
export default {
    name: 'IntlTelInput',
    props: {
        id: {type: String},
        name: {type: String, default: 'phone'},
        value: {type: String},
        label: {type: String},
        required: {type: Boolean, default:false},
        disabled: {type: Boolean, default: false},
    },
    data() {
        return {
            inputValue: this.value,
            intlTelInput: null,
            empty: false,
            invalid: false,
        }
    },
    watch: {
        value() {
            this.intlTelInput.setNumber(this.value);
            this.inputValue = this.intlTelInput.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
        }
    },
    mounted() {
        this.intlTelInput = intlTelInput(this.$refs.input, {
            utilsScript: intlTelInputUtilsURL,
            preferredCountries: [],
            separateDialCode: true,
            initialCountry: "auto",
            geoIpLookup: function (callback) {
                const ipInfoRequest = new XMLHttpRequest();
                ipInfoRequest.overrideMimeType("application/json");
                ipInfoRequest.open('GET', `https://ipinfo.io/?token=${process.env.MIX_IPINFO_TOKEN}`, true);
                ipInfoRequest.onload = function () {
                    let json = ipInfoRequest.responseText && JSON.parse(ipInfoRequest.responseText);
                    callback(json && json.country ? json.country : "es");
                };
                ipInfoRequest.send()
            },
        });
        this.$refs.input.addEventListener("countrychange", this.clear);
    },
    methods: {
        clear() {
            this.empty = false;
            this.invalid = false;
            if (!this.disabled) {
                this.inputValue = '';
                this.intlTelInput.setNumber('');
                this.$emit('input');
                this.$emit('change');
            }
        },
        change() {
            let value = this.intlTelInput.getNumber();
            this.empty = !value;
            this.invalid = this.empty || !this.intlTelInput.isValidNumber();

            if (this.empty) {
                this.$emit('input');
                this.$emit('change');
            }

            if (!this.invalid) {
                this.$emit('input', value);
                this.$emit('change');
            }
        }
    }
}
</script>
